import React from 'react'
import SUI from 'shared/components/ui/SUI'
import Screen from 'components/Screen'
import styles from './styles.less'

export default function LoginLayout({ greeting, tagline, children }) {
  return (
    <SUI transparent={false}>
      <Screen className={styles.Login}>
        <div className={styles.logo} />
        <div className={styles.greeting}>{greeting}</div>
        <div className={styles.tagline}>{tagline}</div>
        {children}
      </Screen>
    </SUI>
  )
}
